import React from 'react';
import clsx from 'clsx';
import { TitleImage } from '../AboutPageGeneralComp';

/**
 * This component is used in markdown component that is rendered in aboutPage page.
 * It contains info about how to create a new page
 */
const CreateNewPage = ({elSubRefs}) => (
    <div id="Group8Sub10" ref ={elSubRefs[9]} className={clsx("subgroup")}>
        <h4 id="Group8Sub10">Create a new page</h4>
        {/**
         * Every TitleImage component contains an image and a title.Title describes the image.
         */}
        <TitleImage 
            title = 'You can now create a new page by clicking on the "+" button.'
            srcImg = '/images/AboutPageMarkdownImg/18.jpg'
        />
        <TitleImage 
            title = 'You can now set a name for your new page.'
            srcImg = '/images/AboutPageMarkdownImg/19.jpg'
        />
    </div> 
)

export default CreateNewPage;